const DROPDOWN_INJECTION_KEY = Symbol("elDropdown");
export { DROPDOWN_INJECTION_KEY };